import {createContext, useContext} from "react";
import Combatant from "@/encounter/model/Combatant.ts";
import {getAttribute} from "@/characters/model/AttributeStat.ts";
import type {CombatCommand, CombatTurnToken, TurnState} from "@/api/TurnApi.ts";

export type TurnProviderReturn = {
    combatState: TurnState;
    runCombatCommand: (command: Omit<CombatCommand, "expectedRevision">) => Promise<void>;
    actingCombatants: CombatTurnToken[];
    initiativeCombatants: CombatTurnToken[];
    nextRoundCombatants: CombatTurnToken[];
    remainingCombatants: CombatTurnToken[];
    activeCombatantId?: string;
    initialLoading: boolean;
    activeCombatant: Combatant | undefined;
    setActiveCombatant: (combatant: Combatant | undefined) => Promise<void>;
    isActiveCombatant: (combatant: Combatant) => boolean;
    round: number,
    setRound: (round: number) => Promise<void>,
    undoTurn: () => Promise<void>;
    advanceTurn: () => Promise<void>;
    startCombat: () => Promise<void>;
    resetCombat: () => Promise<void>;
}

export const TurnContext = createContext<TurnProviderReturn | null>(null)

export function useTurn(): TurnProviderReturn {
    const turn = useContext(TurnContext);
    if (!turn) {
        throw new Error("useTurn must be used within a Provider")
    }
    return turn;
}


export function isAllowedToAct(combatant: CombatTurnToken): boolean {
    return (combatant.currentLife > 0 || !combatant.hostile) && combatant.initiative != null;
}

export const rollInitiative = (combatant: Combatant): number => {
    return Math.floor(Math.random() * (20) + 1) + (getAttribute(combatant.character.attributes, "dex")?.modifier ?? 0);
}
